import '../vendor';

import '../general/ofi';
import '../general/anchor';
import '../general/menu.js';
import '../general/find';
import '../general/search-clear';
import '../general/aside-inputs';

import './one-exponat/modal-exponat';
import './one-exponat/slide-exponat';
import './one-exponat/exponat-zoom';
import './one-exponat/exponat-scroll';


// WEBPACK FOOTER //
// ./src/js/pages/one-exponat.js